import { app } from '../../../../bootstrap/core';
import { TransferringService } from './transferring.service';
import { TransferringStates, TransferringConfirmSuccessState } from './transferring.constants';
import './uploadWarrant/uploadWarrant';
import './confirmWarrant/confirmWarrant';
import './successfulConfirm/successfulConfirm';

app.service('transferringService', TransferringService);
app.constant('TransferringStates', TransferringStates);
app.constant('TransferringConfirmSuccessState', TransferringConfirmSuccessState);
